export const CHANGE_PASS_REQUEST = 'CHANGE_PASS_REQUEST'
export const CHANGE_PASS_SUCCESS = 'CHANGE_PASS_SUCCESS'
export const CHANGE_PASS_FAILED = 'CHANGE_PASS_FAILED'
export const CHANGE_PASS_RESET = 'CHANGE_PASS_RESET'
